import { Autocomplete, styled } from "@mui/material";

export const CustomAutocomplete = styled(Autocomplete)(({}) => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    height: "35px",
    borderRadius: "4px",
    borderColor: "var(--Boxider-bg)",
    color: "var(--color-airline-code)",
    fontSize: "14px",
    fontFamily: "Outfit",
    backgroundColor: "var(--color-bg-white)",
    transition: "background-color 0.3s ease, border-color 0.3s ease",

    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--color-primary-light)",
    },
    "&.Mui-focused": {
      backgroundColor: "var(--input-bg-color)",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "var(--color-primary-light)",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--Boxider-bg)",
    },
    "& .MuiAutocomplete-endAdornment": {
      display: "none",
    },
  },
  "& .MuiInputBase-input": {
    fontWeight: 500,
  },
}));
